module.exports = __webpack_public_path__ + "img/三门控制器 (5).66abe148.jpg";